<template>
  <div>
    <a-divider class="title">
      <h1 class="title__text text-center">Let's find an amazing country</h1>
    </a-divider>

    <div class="world-map">
      <img
        class="world-map__img"
        src="/static/img/wt-world.png"
        alt="World map image"
        width="669"
      />
    </div>
    <!-- <a-card hoverable>
      <img slot="cover" alt="World map image" src="/static/img/wt-world.png" />
      <a-card-meta title="World map image">
        <template slot="description"> World map image </template>
      </a-card-meta>
    </a-card> -->
    <a-card>
      <a-form class="form-finder" :form="form" @submit.prevent="getCountries">
        <!-- success -->
        <!-- :validate-status="countryNameError() ? 'error' : ''"
        :help="countryNameError() || ''" -->
        <a-form-item label="Country name" has-feedback>
          <a-input
            placeholder="Country name"
            v-decorator="decorators.countryName"
          >
            <a-icon slot="suffix" type="search" />
          </a-input>
        </a-form-item>
        <a-row>
          <a-col :span="24" class="text-right">
            <a-button
              :loading="loading"
              :disabled="hasErrors(form.getFieldsError())"
              type="primary"
              size="large"
              html-type="submit"
            >
              Search
            </a-button>
            <a-button
              class="form-finder__cancel"
              size="large"
              @click="handleReset"
            >
              Cancel
            </a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-card>
    <CountriesCard :countries="countries"></CountriesCard>
  </div>
</template>

<script>
import axios from 'axios';
import CountriesCard from '@/components/countries/CountriesCard.vue';
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}
export default {
  components: { CountriesCard },
  data() {
    return {
      loading: false,
      // publicPath: process.env.BASE_URL,
      hasErrors,
      countries: null,
      // formLayout: 'vertical',
      form: this.$form.createForm(this, {
        name: 'form-country-finder',
      }),
      decorators: {
        countryName: [
          'countryName',
          {
            rules: [
              { required: true, message: 'Please input a country name!' },
              { min: 2, message: 'Min characters 2' },
              { max: 10, message: 'Max characters 10' },
            ],
          },
        ],
      },
    };
  },
  methods: {
    handleReset() {
      this.form.resetFields();
      this.countries = null;
      // this.form.validateFields();
    },
    // Only show error after a field is touched.
    countryNameError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched('countryName') && getFieldError('countryName');
    },
    getCountries() {
      const serverAPI = 'http://countries-finder-api.webtraining.fun';
      const url = `${serverAPI}/countries/search`;
      const serviceURL = (countryName) => `${url}/${countryName}`;

      const alternativeServerAPI = 'https://restcountries.com';
      const alternativeUrl = `${alternativeServerAPI}/v2/name`;
      const alternativeServiceURL = (countryName) =>
        `${alternativeUrl}/${countryName}`;

      this.form.validateFields((err, values) => {
        if (err) {
          return;
        }
        this.loading = true;
        // console.log('Received values of form: ', values);
        Promise.any([
          axios.get(serviceURL(values.countryName)),
          axios.get(alternativeServiceURL(values.countryName)),
        ])
          .then((response) => {
            if (response.config.url.includes('webtraining')) {
              this.countries = response.data;
            } else {
              this.countries = response.data.map(
                ({ name: common, alpha2Code: cca2, flag, currencies }) => ({
                  name: {
                    common,
                  },
                  cca2,
                  flag: flag,
                  currency: [currencies[0].code],
                })
              );
            }
            this.loading = false;
          })
          .catch((e) => {
            console.error(e.message);
            this.loading = false;
            this.$message.config({ top: '68px' });
            this.$message.error(e.message);
          });
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      // this.form.validateFields();
    });
  },
};
</script>

<style lang="scss" scoped>
// @media screen and (max-width: 576px) {
//   .ant-divider-horizontal.ant-divider-with-text-center {
//     &::before {
//       width: 4%;
//     }
//     &::after {
//       width: 4%;
//     }
//   }
// }
.title {
  margin: 0 0 16px;

  &.ant-divider-horizontal.ant-divider-with-text-center {
    &::before,
    &::after {
      width: 8%;
      border-top: 1px solid #b9b1b1;
      @media screen and (min-width: 768px) {
        width: 50%;
      }
    }
  }

  &__text {
    font-size: 34px;
    white-space: normal;
    @media screen and (min-width: 768px) {
      white-space: nowrap;
    }
  }
}
.world-map {
  &__img {
    display: block;
    max-width: 100%;
    margin: 0 auto 20px;

    transition: box-shadow 1s ease;

    &:hover {
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.12);
    }
  }
}
.form-finder {
  max-width: 640px;
  padding: 19px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  margin: 0 auto 80px;

  background-color: #ecf0f1;

  &__cancel {
    margin-left: 8px;
  }
}
</style>
